import React from 'react';
import './slider-foamstop-mm-flat.css';
import Foamflat1 from '../../images/FS-mm/fs6.webp';
import Foamflat2 from '../../images/FS-mm/fs6.webp';
function slider() {
	return (
	  
	<>
	<div id="slider-foamstop-mm-flat">
		<div id="carouselExampleIndicators2" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators2" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators2" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Foamflat1} alt="Foam Flat1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>PLAIN (FLAT) DESIGN</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Foamflat2} alt="Foam Flat2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>PLAIN (FLAT) DESIGN</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators2" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators2" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;